<template>
	<div>
		<section class="column flexible">
			<div class="row">
				<label class="field gap padded" :class="validateField(fields.country)">
					<span class="label">Country</span>
					<span class="">
						<select v-validate="'required'" name="country" :disabled="disableInput" @change="onAddressChange" v-model="address.validate.country">
							<option disabled value="">Please select a country</option>
							<option v-for="option in countries" v-bind:key="option.code" v-bind:value="option.code">
								{{ option.name }}
							</option>
						</select>
					</span>
					<small class="label validation error">{{ errors.collect('country')[0] }}</small>
				</label>
			</div>
			<div class="row">
				<label class="field gap" :class="validateField(fields.firstName)">
					<span class="label">First Name</span>
					<input v-validate="'required'" type="text" :disabled="disableInput" name="firstName" @change="onAddressChange()" v-model="address.firstName"/>
					<small class="label validation error">{{ errors.collect('firstName')[0] }}</small>
				</label>
				<label class="field gap" :class="validateField(fields.lastName)">
					<span class="label">Last Name</span>
					<input v-validate="'required'" type="text" :disabled="disableInput" name="lastName" @change="onAddressChange" v-model="address.lastName"/>
					<small class="label validation error">{{ errors.collect('lastName')[0] }}</small>
				</label>
			</div>
			<div class="row">
				<label class="field gap" :class="validateField(fields.organization)">
					<span class="label">Company</span>
					<input type="text" v-validate="'required'" :disabled="disableInput" name="organization" @change="onAddressChange" v-model="address.organization"/>
					<small class="label validation error">{{ errors.collect('organization')[0] }}</small>
				</label>
			</div>
			<div class="row">
				<label class="field gap" :class="validateField(fields.addressLine1)">
					<span class="label">Address Line 1</span>
					<input v-validate="'required'" type="text" placeholder="Street address, no PO box" :disabled="disableInput" name="addressLine1" @change="onAddressChange" v-model="address.validate.addressLine1"/>
					<small class="label validation error">{{ errors.collect('addressLine1')[0] }}</small>
				</label>
			</div>
			<div class="row">
				<label class="field gap" :class="validateField(fields.addressLine2)">
					<span class="label">Address Line 2</span>
					<input type="text" v-validate placeholder="Apartment, suite, unit, building, floor, etc." :disabled="disableInput" name="addressLine2" @change="onAddressChange" v-model="address.validate.addressLine2"/>
				</label>
			</div>
			<div class="row">
				<label class="field gap" :class="validateField(fields.city)">
					<span class="label">City</span>
					<input v-validate="'required'" type="text" :disabled="disableInput" name="city" @change="onAddressChange" v-model="address.validate.city"/>
					<small class="label validation error">{{ errors.collect('city')[0] }}</small>
				</label>
				<label class="field gap" :class="validateField(fields.state)">
					<span class="label">State / Province / Region</span>
					<input v-validate="stateRequired" type="text" :disabled="disableInput" name="state" @change="onAddressChange" v-model="address.validate.state"/>
					<small class="label validation error">{{ errors.collect('state')[0] }}</small>
				</label>
			</div>
			<div class="row">
				<label class="field gap" :class="validateField(fields.postalCode)">
					<span class="label">Postal Code</span>
					<input v-validate="'required|max:8'" type="text" :disabled="disableInput" name="postalCode" @change="onAddressChange" v-model="address.validate.postalCode"/>
					<small class="label validation error">{{ errors.collect('postalCode')[0] }}</small>
				</label>
				<label class="field gap" :class="validateField(fields.phone1)">
					<span class="label">Phone</span>
					<input v-validate="'numeric'" type="tel" :disabled="disableInput" name="phone1" @change="onAddressChange" v-model="address.phone1"/>
					<small class="label validation error">{{ errors.collect('phone1')[0] }}</small>
				</label>
				<!-- <label class="field gap padded" :class="validateField(fields.country)">
					<span class="label">Country</span>
					<span class="select-wrapper">
						<select v-validate="'required'" name="country" @change="onAddressChange" v-model="address.validate.country">
							<option disabled value="">Please select a country</option>
							<option v-for="option in countries" v-bind:key="option.code" v-bind:value="option.code">
								{{ option.name }}
							</option>
						</select>
					</span>
					<small class="label validation error">{{ errors.collect('country')[0] }}</small>
				</label> -->
			</div>
			<!-- <div class="row">
				<label class="field gap" :class="validateField(fields.phone1)">
					<span class="label">Phone</span>
					<input v-validate="'numeric'" type="tel" name="phone1" @change="onAddressChange" v-model="address.phone1"/>
					<small class="label validation error">{{ errors.collect('phone1')[0] }}</small>
				</label>
			</div> -->
		</section>

		<div v-if="error">
			<div ref="errorBox" class="notice warning flip" v-if="error.suggestions || error.original">

				<div v-if="error.suggestions">
					<p>
						We found an address that may work better. Please review the options below and select the version you'd like to use.
					</p>

					<div class="row radio-options">
						<label v-for="(suggested, index) in error.suggestions" v-bind:key="index" tabindex="0" class="gap radio-option">
							<input v-model="validate" name="overrideAddress" type="radio" :value="suggested">
							<address>
								<span class="gap label">Suggested Address <span v-if="error.suggestions > 1">{{index + 1}}</span></span>
								<div>{{suggested.addressLine1}}</div>
								<div v-if="suggested.addressLine2">{{suggested.addressLine2}}</div>
								<div>{{suggested.city}}, {{suggested.state}} {{suggested.postalCode}}</div>
								<div>{{countriesMap[suggested.country].name}}</div>
							</address>
						</label>

						<label tabindex="0" class="gap radio-option">
							<input name="overrideAddress" v-model="validate" type="radio" :value="error.original">
							<address>
								<span class="gap label">Entered Address</span>
								<div>{{error.original.addressLine1}}</div>
								<div v-if="error.original.addressLine2">{{error.original.addressLine2}}</div>
								<div>{{error.original.city}}, {{error.original.state}} {{error.original.postalCode}}</div>
								<div>{{countriesMap[error.original.country].name}}</div>
							</address>
						</label>
					</div>
					<footer class="row separated centering right">
						<button @click="$emit('clear-error')" class="rigid link">Cancel</button>
						<button @click="overrideAddress($event, validate)" class="rigid">Use Selected Address</button>
					</footer>
				</div>

				<div v-else>
					<p>
						Please double-check that you've used a valid, shippable address (no P.O. Box) and try again.
					</p>
					<p>
						If you'd prefer to use the entered address, click the button below.
					</p>
					<div class="row">
						<address class="gap">
							<span class="gap label">Entered Address</span>
							<div>{{error.original.addressLine1}}</div>
							<div v-if="error.original.addressLine2">{{error.original.addressLine2}}</div>
							<div>{{error.original.city}}, {{error.original.state}} {{error.original.postalCode}}</div>
							<div>{{countriesMap[error.original.country].name}}</div>
						</address>
					</div>
					<footer class="row separated centering right">
						<button @click="$emit('clear-error')" class="rigid link">Cancel</button>
						<button @click="overrideAddress($event, error.original)" class="rigid bottom">Use Entered Address</button>
					</footer>
				</div>
			</div>

			<div v-else class="notice error flip">
				Please double-check that you've used a valid, shippable address (no P.O. Box) and try again. If still having trouble, please <a :href="'mailto:address-verification@support.tekcloud.com?subject=%20Error%3A%20' + error.message">email support</a>.
			</div>

		</div>

		<!-- <footer class="row centering">
			<button class="jumbo gap" @click="validateBeforeSubmit(e)" type="submit"></button>
		 </footer>-->

	</div>
</template>

<script>
import { mapState } from 'vuex';
import countries from '@/modules/countries';
import userService from '@/modules/user-service';
export default {
	name: 'AddressForm',
	props: {
		isSubmitting: Boolean,
		error: Object,
		editAddress: Object
	},
	data() {
		return {
			countries: countries.list(),
			countriesMap: countries.map(),
			address:{
				firstName: '',
				lastName: '',
				organization: '',
				validate: {
					addressLine1: '',
					addressLine2: '',
					city: '',
					state: '',
					postalCode: '',
					country: ''
				},
				phone1: '',
				complete: false,
				ignoreValidation: false
			},
			validate: {},
		};
	},
	computed:{
		...mapState({
			ipCountryCode (state) {
				return state.user.user && state.user.user.ipInfo && state.user.user.ipInfo.country_code;
			}
		}),
		stateRequired() {
			return this.address.validate.country !== 'GB' ? 'required' : '';
		},
		formIsValid() {
			return Object.keys(this.fields).every(key => this.fields[key].valid);
		},
		disableInput() {
			return this.isSubmitting || this.editAddress;
		}
	},
	methods:{
		onAddressChange(e, v){
			this.$emit('change', this.mapAddressToDTO(this.address));
		},
		mapAddressToDTO(address){
			return {
				firstName: address.firstName,
				lastName: address.lastName,
				organization: address.organization,
				addressLine1: address.validate.addressLine1,
				addressLine2: address.validate.addressLine2,
				city: address.validate.city,
				state: address.validate.state,
				postalCode: address.validate.postalCode,
				country: address.validate.country,
				phone1: address.phone1 && address.phone1 !== '' ? address.phone1 : undefined,
				complete: this.formIsValid,
				ignoreValidation: address.ignoreValidation
			};
		},
		mapAddressFromDTO(address){
			return {
				firstName: address.firstName,
				lastName: address.lastName,
				organization: address.organization,
				validate: {
					addressLine1: address.addressLine1,
					addressLine2: address.addressLine2,
					city: address.city,
					state: address.state,
					postalCode: address.postalCode,
					country: address.country
				},
				phone1: address.phone1
			};
		},
		validateBeforeSubmit(e) {
			// e.preventDefault();
			let vm = this;
			this.$validator.validateAll()
				.then((result) => {
					if (result) {
						vm.submitForm();
					}
				})
				.catch(() => {
				        return false;
				    });
		},
		validateField(field){
			if (!field) {
				return;
			}
			return {
				'invalid': field.invalid,
				'valid': field.valid,
				'changed': !field.pristine,
				'optional': !field.required,
				'required': field.required
			};
		},
		overrideAddress(e, newAddress){
			e.preventDefault();
			this.address.validate = newAddress;
			this.address.ignoreValidation = true;
			this.$emit('clear-error');
			this.$emit('change', this.mapAddressToDTO(this.address));
		},
		isValidCountry(code){
			return this.countries.find(country => {
				return country.code === code;
			});
		},
		setCountryInput(countryCode){
			let vm = this;
			if (vm.address) {
				vm.address.validate.country = countryCode;
			}
				
			if (vm.fields.country) {
				vm.fields.country.pristine = vm.address.validate.country === '';
			}
		},
		setAddress(val){
			if (val) {
				this.address = this.mapAddressFromDTO(val);
			}
		}
	},
	watch:{
		error(val, old){
			if (val) {
				// const vm = this;
				if (val.suggestions) {
  						this.validate = val.suggestions[0];
				}
				if (this.$refs.errorBox) {
					this.$nextTick()
						.then(()=>{
							this.$refs.errorBox.scrollIntoView();
						});
				}
					
			}
		},
		formIsValid(val, old) {
			this.address.complete = val;
			this.onAddressChange();
		},
		editAddress: {
			handler: 'setAddress',
			immediate: true
		}
	},
	mounted(){
		this.setCountryInput(this.isValidCountry(this.ipCountryCode) ? this.ipCountryCode : '');
	},
	beforeDestroy() {
		this.address = null;
	}
};
</script>

<style scoped>
	.field {
		margin-bottom: 1em;
	}
	input.invalid.dirty,
	input:invalid.dirty {
		border-color: #c00;
		outline-color: #c00;
	}
	.validation.error {
		position: absolute;
		color: #c00;
	}
	label {
		position: relative;
	}

	/* .label {
		font-size: .6875rem;
		text-transform: uppercase;
		margin: 0 0 .3125rem .625rem;
		color: #898989;
		font-weight: 400;
	} */

	.field-assist {
		line-height: 19px;
	}
	p:first-child {
		margin-top: 0;
	}

	p:last-child {
		margin-bottom: 0;
	}

	.notice footer {
		margin-top: 1em;
	}

	.checkbox .validation.error {
		top: 100%;
		left: 0;
	}
	label + button {
		margin-left: .25em;
	}

	label small.left {
		float: none;
	}

	.failed input.invalid,
	.failed input:invalid {
		border-color: #c00;
		outline-color: #c00;
	}

	.required .label:not(.validation):after,
	.checkbox label.required:not(.validation):after  {
		content: "*";
		margin-left: .1875rem;
	}

	.checkbox label.required:after {
		position: absolute;
		margin-left: 2px;
	}

	.radio-options {
		width: 100%;
	}

	.radio-option {
		display: flex;
		align-items: flex-start;
		padding: .8em 10px .8em 32px;
		border: 2px solid #ddd;
		border-radius: 4px;
		position: relative;
		cursor: pointer;
		transition: border-color 0.4s ease, color 0.4s ease;
		background-color: #fff;
		margin: 0;
		text-align: left;
		max-width: none;
		box-sizing: border-box;
		flex-basis: 100%;
	}

	.radio-option + .radio-option {
		margin-left: 1em;
	}

	.radio-option input {
	    position: absolute;
	    left: .8em;
	    top: 1em;
	    bottom: 0;
	}

	.notice.warning .label {
		color: #8F7700;
		margin-left: 0;
	}

	.notice.above {
		margin-bottom: 1em;
		margin-top: 0;
	}

	.notice.below {
		margin-bottom: 0;
		margin-top: 1em;
	}

	.link {
		padding: 10px 6px;
	}

	.notice button.link:not(.close) {
	    text-transform: none;
	 	font-size: 1em;
	}

	.row.separated .link + button.rigid {
	    margin-left: 1em;
	}

	.notice.warning .radio-option {
		border-color: rgba(212,200,144,0.4);
		background-color: rgba(255,255,255, 0.6);
	}

	.notice.warning button:not(.link) {
		background-color: #C5A405;
	    border-color: #C5A405;
		color: white;
	}
	.hoverable .notice.warning button:not(.link):hover {
		background-color: #8F7700;
		border-color: #8F7700;
	}

	address {
		font-weight: 400;
	}



</style>



// WEBPACK FOOTER //
// ./src/components/AddressForm.vue